import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import SideMenu from "components/admin/layout/SideMenu";

const Users: React.FC = () => {
  return (
    <Page>
      <FullWidth>
        <div className="row">
          {/* SIDE MENU */}
          <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12">
            <SideMenu />
          </div>

          {/* CENTRAL CONTENT */}
          <div
            className="col-comp-central col-xl-10 col-lg-9 col-md-9 col-sm-12 offset-xl-1 offset-lg-1 offset-md-1"
            style={{ marginLeft: "15%", marginTop: "-12%" }}
          >
            <Content>
              <ContentInner>
                <NewItem>
                  <RouterLink to="/admin-dashboard/dl-group-edit">
                    novo
                  </RouterLink>
                </NewItem>

                {["redaktor", "test1"].map((item) => (
                  <ListItem key={item}>
                    <RouterLink to={`/admin-dashboard/dl-group-edit/${item}`}>
                      polja
                    </RouterLink>
                    <br />
                    {item.replace(/-/g, " ")}
                    <DeleteText>obriši</DeleteText>
                  </ListItem>
                ))}
              </ContentInner>
            </Content>
          </div>
        </div>
      </FullWidth>
    </Page>
  );
};

export default Users;

const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

const FullWidth = styled.div`
  width: 100%;
`;

// const Header = styled.header`
//   display: flex;
//   align-items: center;
// `;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteText = styled.span`
  margin-left: 3%;
  cursor: pointer;
  color: darkgrey;
`;
